enum VerificationStatusType {
  VALID = 'Valid',
  ACCEPT_ALL = 'AcceptAll',
  UNKNOWN = 'Unknown',
  INVALID = 'Invalid',
}

export interface EmailScrapeResult {
  id?: number;
  email: string;
  verificationStatus: VerificationStatusType;
}

export interface PhoneScrapeResult {
  id?: number;
  phone: string;
}

export default VerificationStatusType;
